import { UnitDTO } from "./unit.model";

export class WarrantyDTO {
    type: string;
    period: UnitDTO;
    policy: string;

    constructor(
        type: string = "",
        period: UnitDTO = new UnitDTO(),
        policy: string = "",
    ) {
        this.type = type;
        this.period = period;
        this.policy = policy;
    }
}
